module.exports = __webpack_public_path__ + "img/dealsandconfirm-grey.94d69754.svg";